export default __webpack_public_path__ + "static/homepage_AU-dc5f719bb96630ba696b70b7793c9d84.mp4";